import API from '../api'
import putUrl from './paths'

export const updateBankFacilitiesApi = ({ probe42Id, facilities, bankName }, isSecured) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateBankFacilities, [...facilities], { probe42Id, bankName, isSecured })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
